import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';

const CommonLoader = () => {
  return (
    <div style={{display: "flex", flexDirection: "column"}}>
        <Box style={{display: "flex", justifyContent: "center"}}>
            <CircularProgress />
        </Box>
        <div style={{display: "flex", justifyContent: "center", marginTop: "15px"}}>Loading...</div>
    </div>
  )
}

export default CommonLoader